import { render, staticRenderFns } from "./HolidayComp.vue?vue&type=template&id=4a9a45a4&scoped=true"
import script from "./HolidayComp.vue?vue&type=script&lang=js"
export * from "./HolidayComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a45a4",
  null
  
)

export default component.exports